import $ from 'jquery';
// import hotkeys from 'hotkeys-js';
import InputService from '../service/InputService';

function checkPlaceholder(controlInput) {
    setTimeout(() => {
        const placeholder = controlInput.parents('.control').find('.control-input__placeholder');
        if (controlInput.val() !== '') {
            placeholder.hide();
        } else {
            placeholder.show();
        }
    }, 0)
}

$('.control-input').each(function () {
    checkPlaceholder($(this));
});

$('.control-input--date').mask('00.00.0000');

$('.control-input').blur(function () {
    const id = $(this).parents('.control').attr('data-id');
    InputService.setValue(id, $(this).val());
});

$('.control-input').keyup(function (event) {
    if (event.keyCode == 13) {
        $('.control-input').blur();
    }
});

$('body').on('click', '.control-input__icon', function () {
    $(this).closest('.control-input').blur();
});

$('.control-input').keydown(function (e) {
    checkPlaceholder($(this));
});

$('.control-input--only-letters').keydown(function (e) {
    if (!isNaN(e.key)) {
        return false;
    }
});
